import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getBikeCharacteristic } from './bikeThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearBikeKey } from '../../sell/sellKeys';
const SLICE_NAME = 'characteristic';

export const bikeCharacteristicSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearBikeCharacteristic(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getBikeCharacteristic }).addCase(
            clearBikeKey,
            () => commonInitialState,
        );
    },
});

export const { clearBikeCharacteristic } = bikeCharacteristicSlice.actions;

export const characteristic = bikeCharacteristicSlice.reducer;
